export default __webpack_public_path__ + "static/media/fnl_newhome_acf.99e062a5.jpg";